import { transactionDetailsFormFactory } from 'app-components/flux/transactions/transactionDetailsForm';
import { createFormHooks } from 'app-components/utils/createForm/formHooks';

export const { FormProvider, ...transactionDetailsFormHooks } = createFormHooks(transactionDetailsFormFactory);
